<template>
  <v-container class="pa-0 mt-n1 mb-1">
    <v-row no-gutters>
      <!-- Komponenty se přizpůsobí velikosti obrazovky -->
      <v-col v-for="(item, index) in tempdata" :key="item.temp_id" :cols="4" :sm="6" :md="4" :lg="3">
        <!-- Obsah každého sloupce -->
        <!-- {{ chartdata[item.temp_id] }} -->
        <TempGraph :chart-data="chartdata[item.temp_id]" :tempSensorData="item" />
        <!-- :chart-data="chartdata[item.temp_id]" -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TempGraph from "./TempGraph.vue";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
// {'temp_id': 134, 'temp': 21.6, 'status': True}
export default {
  components: {
    TempGraph,
  },
  data() {
    return {
      // { x: "2021-11-06 10:39:30", y: 25.5 }, chardata example
      // { x: "2021-11-06 10:39:30", y: 25.5 },
      tempdata: [],
      chartdata: {},
    };
  },
  mounted() {
    this.initTempSensors();
  },
  computed: {
    // Připojení na Vuex state
    tempchart() {
      return this.$store.state.temp.tempgraph;
    },
    temperature() {
      return this.$store.state.temp.tempdata;
    },
  },
  watch: {
    // Sledování změn Vuex stavu temperature
    temperature(newValue) {
      this.tempdata = newValue;
    },
    tempchart(newValue) {
      this.chartdata = newValue;
    },
  },
  methods: {
    test() {
      console.log(this.chartdata);
    },
    initTempGraph() {
      this.$store.dispatch("temp/getTempGraph");
    },
    async initTempSensors() {
      try {
        const response = await axios.get("/getTempSensors");
        this.tempdata = response.data;
        this.initTempData();
        this.initTempGraph();
      } catch (err) {
        // Ošetření chyby
        this.error = "Nepodařilo se načíst data.";
        console.error(err);
      } finally {
        // Ukončení načítání
        // this.loading = false;
      }
    },

    initTempData() {
      this.$store.dispatch("temp/getTempData").then(
        (response) => {
          this.tempdata = response.data;
        },
        (error) => {
          console.log(error);
          // this.ShowErrorDialog(error);
        }
      );
    },
  },
};
</script>
